@import './pk-dropdown.variables';

:host {
  @apply relative inline-block;
}

.pk-dropdown__panel {
  @apply fixed z-[900] min-w-[--dropdown--width] rounded-[--dropdown--border-radius];
  @apply bg-[color:--dropdown--background-color] text-m leading-m text-text-02 shadow-03 transition-opacity duration-250;

  .arrow {
    &,
    &::before {
      @apply absolute z-[-1] h-[--dropdown--arrow-size] w-[--dropdown--arrow-size];
    }

    &::before {
      @apply left-0 top-0 rotate-45 bg-[color:--dropdown--background-color] content-[''];
    }
  }

  ::slotted(pk-menu) {
    @apply [--menu--border-radius:--dropdown--border-radius];
    @apply h-[--dropdown--height] max-h-[calc(100vh-var(--dropdown--v-offset)-var(--pk-spacing-m))] overflow-y-auto;
  }
}
